import merge from 'deepmerge';
import type { UserPreferences, UserPreferencesInput } from '../../styleApplicator.types';
import { DEFAULT_USER_PREFERENCES } from '../constants';

// Color arrays ([r, g, b, a]) are replaced wholesale, never element-merged with the defaults.
const arrayOverwriteMerge = (_destinationArray: unknown[], sourceArray: unknown[]) => sourceArray;

export const ensureUserPreferences = (preferences?: UserPreferencesInput): UserPreferences => {
  if (!preferences) {
    return DEFAULT_USER_PREFERENCES;
  }

  const mergedPreferences = merge(DEFAULT_USER_PREFERENCES, preferences, { arrayMerge: arrayOverwriteMerge }) as UserPreferences;
  return mergedPreferences;
};
